import type { Interceptor } from '@connectrpc/connect'
import { createConnectTransport } from '@connectrpc/connect-web'
import { apiHost } from '@customer/config'
import { QueryClient } from '@tanstack/react-query'

/** URLのクエリパラメータからshare link tokenを取得する */
export function getShareToken(): string {
  if (typeof window === 'undefined') return ''
  const params = new URLSearchParams(window.location.search)
  return params.get('token') ?? ''
}

const shareTokenInterceptor: Interceptor = next => async req => {
  req.header.set('Accept', 'application/json')
  req.header.set('Content-Type', 'application/json')
  const token = getShareToken()
  if (token) {
    req.header.set('Authorization', `Bearer ${token}`)
  }
  return await next(req)
}

export const transport = createConnectTransport({
  baseUrl: apiHost,
  interceptors: [shareTokenInterceptor],
  useHttpGet: true,
})

/**
 * 口コミフロー（/review/:slug）専用 transport。
 * share link token を注入しない（無認証エンドポイント。Authorization ヘッダを付けない）。
 * 認証は不要で、bot 防止は Cloudflare Turnstile + サーバ側 rate limit で担保する。
 */
export const reviewTransport = createConnectTransport({
  baseUrl: apiHost,
  useHttpGet: true,
})

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      retry: false,
    },
  },
})
